/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import SideList from "./sideBar/SideList";
import DarkMode from "./sideBar/DarkMode";
import logo from "../../assets/beeSQL_Logo_Stacked.png";
import { useSelector } from "react-redux";
import UserDisplay from "./sideBar/UserDispaly";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserShield, faChartLine, faPlu, faLink, faDatabase, faCircleNodes, faLanguage } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from "react-router-dom"; // ⬅
import { useI18n } from "../../utils/i18n";


const SideBar = ({ setDashMain }) => {
  const database = useSelector((state) => state.database);
  const userState = useSelector((state) => state.userState);
  const showBiBeta = Number(userState.user?.bi_tool_on_off) === 1;
  const [openList, setOpenList] = useState({ current: [] });
  const { language, setLanguage, t } = useI18n();
  const history = useHistory(); // ⬅

  const goHome = () => history.push("/"); // ⬅ helper


  useEffect(() => {
    const hasRealCompany = (items) =>
      Array.isArray(items) &&
      items.some((item) => {
        const companyName = String(item?.company_name || "").toLowerCase();
        return !companyName.includes("add new location");
      });

    setOpenList((currentOpenList) => {
      if (currentOpenList.current.length > 0) return currentOpenList;

      const listsWithCompanies = [
        { id: 1, items: database.retail },
        { id: 2, items: database.resto },
        { id: 9, items: database.restoK },
        { id: 11, items: database.retailX },
      ]
        .filter(({ items }) => hasRealCompany(items))
        .map(({ id }) => id);

      return listsWithCompanies.length > 0
        ? { current: listsWithCompanies }
        : currentOpenList;
    });
  }, [database.retail, database.resto, database.restoK, database.retailX]);

  return (
    <div className="side-bar relative">
      <div className="side-bar-logo-wrapper">
        <img src={logo} alt="logo" width="32px" height="32px" />
      </div>

      <div className="language-switch" aria-label={t("Language selector")}>
        <div className="language-switch-label">
          <FontAwesomeIcon icon={faLanguage} />
          <span>{t("Language")}</span>
        </div>
        <div className="language-switch-options">
          <button
            type="button"
            className={language === "en" ? "language-switch-option active" : "language-switch-option"}
            onClick={() => setLanguage("en")}
            aria-pressed={language === "en"}
            title={t("English")}
          >
            EN
          </button>
          <button
            type="button"
            className={language === "fr-CA" ? "language-switch-option active" : "language-switch-option"}
            onClick={() => setLanguage("fr-CA")}
            aria-pressed={language === "fr-CA"}
            title={t("French (Canada)")}
          >
            FR
          </button>
        </div>
      </div>
      {showBiBeta && (
        <div
          onClick={() => {
            history.push("/bi-beta");
          }}
          className="side-label side-label-dash"
        >
          <span>BI Beta</span>
          <FontAwesomeIcon icon={faDatabase} />
        </div>
      )}

      <UserDisplay userState={userState} />

      {/* Integration Settings -> ide na /integration-settings */}
      <div
        onClick={() => {
          history.push("/integration-settings"); // ⬅ OTVORI settings
        }}
        className="side-label side-label-dash"
      >
        <span>{t("Integration Settings")}</span>
        <FontAwesomeIcon icon={faLink} />
      </div>

      {/* Admin -> vrati se na root (/) */}
      <div
        onClick={() => {
          goHome();               // ⬅ VRATI NA /
          setOpenList({ current: [] });
          setDashMain(true);
        }}
        className="side-label side-label-dash"
      >
        <span>{t("Dashboard")}</span>
        <FontAwesomeIcon icon={faChartLine} />
      </div>

      <div className="side-list-inner-wrapper">
        <SideList
          setDashMain={(v) => { goHome(); setDashMain(v); }}   // ⬅ pri bilo kojem izboru vrati na /
          label="Retail (R)"
          list={database.retail}
          current={database.currentCompany}
          listN={1}
          openList={openList}
          setOpenList={(v) => { goHome(); setOpenList(v); }}   // ⬅ sigurnosno
        />

        <SideList
          setDashMain={(v) => { goHome(); setDashMain(v); }}   // ⬅ isto
          label="Retail (X)"
          list={database.retailX}
          current={database.currentCompany}
          listN={11}
          openList={openList}
          setOpenList={(v) => { goHome(); setOpenList(v); }}
        />

        <SideList
          setDashMain={(v) => { goHome(); setDashMain(v); }}
          label="Restaurant (L)"
          list={database.resto}
          current={database.currentCompany}
          listN={2}
          openList={openList}
          setOpenList={(v) => { goHome(); setOpenList(v); }}
        />
        <SideList
          setDashMain={(v) => { goHome(); setDashMain(v); }}
          label="Restaurant (K)"
          list={database.restoK}
          current={database.currentCompany}
          listN={9}
          openList={openList}
          setOpenList={(v) => { goHome(); setOpenList(v); }}
        />
      </div>

      <DarkMode />
    </div>
  );
};

export default SideBar;
